import { Component, inject, LOCALE_ID, OnInit, SecurityContext } from '@angular/core';
import { WindowService } from '@big-direkt/utils/environment';
import { ChatService } from '../services/chat.service';
import { MessagesService } from '../services/messages.service';
import { Message } from '../interfaces/message';
import { SanitizePipe } from '@big-direkt/utils/shared';

@Component({
    selector: 'big-chat-live',
    templateUrl: './live.component.html',
    imports: [SanitizePipe],
})
export class LiveComponent implements OnInit {
    private readonly chatService = inject(ChatService);
    private readonly messagesService = inject(MessagesService);
    private readonly windowService = inject(WindowService);
    public readonly locale = inject(LOCALE_ID);
    public readonly securityContext = SecurityContext;

    public iFrameUrl!: string;

    public ngOnInit(): void {
        const config = this.chatService.config();
        const messages = this.messagesService.messages();
        const urlParams: string[] = [];

        const hin: string | undefined = config.user.hin;

        if (hin !== undefined) {
            urlParams.push(`userdata=KVN=${hin}`);
        }

        urlParams.push(`name=${config.user.name ?? 'Anonymous'}`);
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        urlParams.push(`url=${this.windowService.nativeWindow()?.location}`);

        if (messages.length > 0) {
            urlParams.push(`msg=${this.createInitMessage(messages)}`);
        }

        this.iFrameUrl = encodeURI(`${config.live.service ?? ''}?${urlParams.join('&')}`);
    }

    private createInitMessage(messages: Message[]): string {
        let res = 'ChatBot Verlauf: \n';

        messages.forEach(message => {
            res += '------------------------ \n';
            res += `${message.isBot ? 'Bot' : 'User'} am ${new Date(message.time).toLocaleString(this.locale)} \n`;
            res += `${message.text} \n\n`;
        });

        // eslint-disable-next-line sonarjs/slow-regex
        return res.replace(/(<([^>]+)>)/gi, '');
    }
}
